<template>
  <el-main v-loading="loading">
    <div style="margin-bottom: 10px;">
      <el-button @click="showImportDialog" size="small" type="success">导入会员</el-button>
    </div>
    <div class="search-box">
      <el-form class="el-form-search" label-width="90px">
        <el-form-item label="会员分类：">
          <el-cascader
            v-model="searchForm.categories"
            :options="goodsClass"
            multiple
            style="width: 100%"
            placeholder="请选择或搜索"
            clearable
            filterable
            :props="{ multiple: true }"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="会员昵称：">
          <el-input v-model="searchForm.nickname" size="small" placeholder="请输入会员昵称"></el-input>
        </el-form-item>
        <el-form-item label="联系人：">
          <el-input v-model="searchForm.name" size="small"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：">
          <el-input v-model="searchForm.mobile" size="small"></el-input>
        </el-form-item>
        <el-form-item label="注册日期：">
          <el-date-picker
            v-model="searchForm.create_time"
            size="small"
            type="daterange"
            value-format="timestamp"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="省：">
          <el-input v-model="searchForm.province" size="small" placeholder="请输入省份"></el-input>
        </el-form-item>
        <el-form-item label="市：">
          <el-input v-model="searchForm.city" size="small" placeholder="请输入城市"></el-input>
        </el-form-item>
        <el-form-item label="区：">
          <el-input v-model="searchForm.area" size="small" placeholder="请输入区域"></el-input>
        </el-form-item>
        <el-form-item label=" " label-width="20px">
          <el-button size="small" @click="search" type="primary">搜索</el-button>
          <el-button size="small" @click="searchClear" type="text">清除搜索条件</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="list" :header-cell-style="{ 'background-color': '#F8F9FA' }" row-key="id">
      <template slot="empty">
        <No />
      </template>
      <el-table-column prop="enterprise_name" label="单位名称" width="200" align="center"></el-table-column>
      <el-table-column prop="province" label="省" width="100" align="center"></el-table-column>
      <el-table-column prop="city" label="市" width="100" align="center"></el-table-column>
      <el-table-column prop="area" label="区" width="100" align="center"></el-table-column>
      <el-table-column label="分类" align="center">
        <template v-slot="{ row }">
          <template v-if="row.category_name && row.category_name.length">
            {{ row.category_name.join('、') }}
          </template>
          <template v-else>-</template>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="联系人" width="100" align="center"></el-table-column>
      <el-table-column prop="position" label="联系人职务" width="100" align="center"></el-table-column>
      <el-table-column prop="mobile" label="手机" width="120" align="center"></el-table-column>
      <el-table-column prop="address" label="通讯地址" width="200" align="center"></el-table-column>
      <el-table-column prop="website" label="企业官网" width="200" align="center"></el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="200">
        <template v-slot="{ row }">
          <el-button @click="details(row)" type="text" size="small">详情</el-button>
          <el-button @click="showUpdateCateDialog(row)" type="text" size="small">更新分类</el-button>
          <!-- <el-button @click="retirement(row.id)" type="text" size="small">清退</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <Paging :total="total_number" :page="searchForm.page" :pageNum="searchForm.rows" @updatePageNum="updateData"></Paging>
    <el-dialog :visible.sync="dialogVisible" title="详细信息" width="80%" top="5vh">
      <div class="detail-container">
        <h3 class="company-title">{{ detail.enterprise_name }}</h3>

        <div class="detail-section">
          <div class="section-title">基本信息</div>
          <div class="info-grid">
            <div class="info-item">
              <span class="label">工商成立时间：</span>
              <span class="value">{{ detail.establishment_time || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">工商注册资本：</span>
              <span class="value">{{ detail.registered_capital || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">联系方式来源：</span>
              <span class="value">{{ detail.comefrom_text || '-' }}</span>
            </div>
          </div>
        </div>

        <div class="detail-section">
          <div class="section-title">主营范围</div>
          <div class="content-box">
            {{ detail.main_manage || '-' }}
          </div>
        </div>

        <div class="detail-section">
          <div class="section-title">企业简介</div>
          <div class="content-box">
            {{ detail.main_equipment || '-' }}
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="更新会员分类" :visible.sync="cateDialogVisible" width="500px">
      <el-form :model="cateForm" label-width="100px">
        <el-form-item label="分类">
          <el-cascader
            v-model="cateForm.categories"
            :options="goodsClass"
            multiple
            style="width: 100%"
            placeholder="请选择或搜索"
            clearable
            filterable
            :props="{ multiple: true }"
          >
          </el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="cateDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitUpdateCate">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导入会员" :visible.sync="importDialogVisible" width="500px">
      <el-form :model="importForm" label-width="100px">
        <el-form-item label="分类">
          <el-cascader
            v-model="importForm.categories"
            :options="goodsClass"
            multiple
            style="width: 100%"
            placeholder="请选择或搜索"
            clearable
            filterable
            :props="{ multiple: true }"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="Excel文件">
          <el-upload
            ref="upload"
            :action="'https://tapi.360ep.cn/admin/Gateway/MemberImport/import'"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :show-file-list="false"
            :limit="1"
            :headers='{
              "access-token" : token,
            }'
            :data="{ cate_id: importForm.categories.join(',') }"
            accept=".xls,.xlsx"
            name="file"
          >
            <el-button size="small" type="primary">选择文件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="importDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { getDateformat } from '@/util/getDate';
import Paging from '@/components/paging';
import _ from 'lodash';
import cookies from "vue-cookies";
const industryName = '/Gateway';
export default {
  components: {
    Paging,
  },
  data() {
    return {
      searchForm: {
        page: 1,
        rows: 10,
        nickname: '',
        name: '',
        mobile: '',
        type: '',
        is_shop: '',
        identity_type: '',
        city_id: '',
        create_time: [],
        province: '',
        city: '',
        area: '',
        categories: [],
      },
      cityList: [],
      list: [],
      total_number: 0,
      dialogVisible: false,
      detail: {},
      token: '',
      loading: false,
      cateDialogVisible: false,
      cateForm: {
        categories: []
      },
      currentMemberId: null,
      importDialogVisible: false,
      importForm: {
        categories: []
      }
    };
  },
  filters: {
    getDateformat: getDateformat,
    identityName(type) {
      let name = '';
      switch (type) {
        case 0:
          name = '个人会员';
          break;
        case 1:
          name = '企业会员';
          break;
        case 2:
          name = '个人会员商家';
          break;
        case 3:
          name = '企业会员商家';
          break;
        case 4:
          name = '供应商品商家';
          break;
        case 5:
          name = '代销商家';
          break;
        case 6:
          name = '产品合伙人';
          break;
        case 7:
          name = '城市合伙人';
          break;
        case 8:
          name = '市场合伙人';
          break;
      }
      return name;
    },
  },
  created() {
    this.token = cookies.get('token');
    this.$axios.get(this.$api.set.area, { tree: 1, level: 2 }).then(res => {
      if (res.code == 0) {
        let list = res.result.list;
        for (let i in list) {
          for (let y in list[i]._child) delete list[i]._child[y]._child;
        }
        this.cityList = list;
      }
    });
    this.getList();
    this.$store.dispatch('goods/getTypeList', { industryName });
  },
  computed: {
    goodsClass () {
      return this.$store.getters.goodsTypeList;
    },
  },
  methods: {
    search() {
      this.searchForm.page = 1;
      this.getList();
    },
    searchClear() {
      this.searchForm = {
        page: 1,
        rows: 10,
        nickname: '',
        name: '',
        mobile: '',
        type: '',
        is_shop: '',
        identity_type: '',
        city_id: '',
        create_time: [],
        categories: [],
        province: '',
        city: '',
        area: '',
      };
      this.getList();
    },
    details(row) {
      this.dialogVisible = true;
      this.detail = row;
    },
    updateData(e, type) {
      if(type === 0) {
        this.searchForm.rows = e;
      }
      if(type === 1) {
        this.searchForm.page = e;
      }
      this.getList();
    },
    getList() {
      let searchForm = _.cloneDeep(this.searchForm);
      for (let i in searchForm.create_time) searchForm.create_time[i] = searchForm.create_time[i] / 1000;
      if (searchForm.city_id) {
        searchForm.province_id = searchForm.city_id[0];
        searchForm.area_id = searchForm.city_id[2];
        searchForm.city_id = searchForm.city_id[1];
      }
      if (searchForm.categories.length) {
        searchForm.cate_id = searchForm.categories.join(',');
      }
      const params = JSON.parse(JSON.stringify(searchForm));
      delete params.categories;
      this.$axios.post(this.$api.gateway.MemberImport.list, params).then(res => {
        if (res.code == 0) {
          let list = res.result.list;
          for (let i in list) list[i].identity_type = list[i].identity_type.split(',').map(Number);
          this.list = list;
          this.total_number = res.result.total_number;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    beforeUpload() {
      if (!this.importForm.categories.length) {
        this.$message.warning('请先选择分类')
        return false
      }
      this.loading = true
    },
    uploadSuccess(response) {
      this.loading = false
      if (response.code === 0) {
        this.$message.success('导入成功')
        this.importDialogVisible = false
        this.getList()
        this.$refs.upload.clearFiles()
      } else {
        this.$message.error(response.msg || '导入失败')
        this.$refs.upload.clearFiles()
      }
    },
    uploadError() {
      this.loading = false
      this.$message.error('导入失败')
      this.$refs.upload.clearFiles()
    },
    showUpdateCateDialog(row) {
      this.currentMemberId = row ? row.id : null
      this.cateForm.categories = []
      this.cateDialogVisible = true
    },
    async submitUpdateCate() {
      try {
        const params = {
          id: this.currentMemberId,
          cate_id: this.cateForm.categories.join(',')
        }
        await this.$axios.post('/Gateway/MemberImport/updateMemberData', params)
        this.$message.success('更新分类成功')
        this.cateDialogVisible = false
        this.getList()
      } catch (error) {
        console.error(error)
      }
    },
    showImportDialog() {
      this.importDialogVisible = true
      this.importForm.categories = []
    }
  },
};
</script>

<style lang="less" scoped>
.el-main {
  background: #fff;
}

.detail-container {
  padding: 20px;

  .company-title {
    font-size: 20px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 24px;
    text-align: center;
  }

  .detail-section {
    margin-bottom: 24px;

    .section-title {
      font-size: 16px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 16px;
      padding-left: 10px;
      border-left: 4px solid #409EFF;
    }

    .info-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;

      .info-item {
        .label {
          color: #606266;
          margin-right: 8px;
        }
        .value {
          color: #303133;
        }
      }
    }

    .content-box {
      padding: 16px;
      background: #f8f9fa;
      border-radius: 4px;
      line-height: 1.6;
      color: #303133;
      min-height: 60px;
    }
  }
}
</style>
